import { generatePath } from "react-router-dom";
import slug from "slug";
import { FlowStep } from "./pages/configurator/stepTemplates";

// change handling of "/" to be "-" instead of default empty space ""
slug.charmap["/"] = "-";

// Auth Routes
export const signInPath = "/signIn";
export const signUpPath = "/signUp";
export const enterCodePath = "/enterCode";
// Note, v6 react router needs us to drop the regex (\\d+) for the linkCode param unlike HOPs route def
export const verifyCodePath = "/verifyCode/:linkCode";
export const googleCallback = "/auth/gcallback";

// Landing page
export const configurationsLandingPath = "/configurations";
export function createConfigurationsLandingUrl() {
  return generatePath(configurationsLandingPath);
}

// Unauthorized user page
export const unauthorizedUserPath = "/unauthorized";
export function createUnauthorizedUserUrl() {
  return generatePath(unauthorizedUserPath);
}

// checkout step 1, pick your community
export const communitiesPath = "/communities";
export function createCommunitiesUrl() {
  return generatePath(communitiesPath);
}

// checkout step 2, pick your lot
export const lotsPath = `/:communityId/lots`;
export function createLotsUrl(communityId: string) {
  return generatePath(lotsPath, { communityId });
}

// checkout step 3a, pick your plan before creating a config
export const planSelectionPath = `/communities/:communityId/lot/:structureId/plan`;
export function createPlanSelectionUrl(communityId: string, structureId: string) {
  return generatePath(planSelectionPath, { communityId, structureId });
}

// checkout step 3b and onward, i.e. each next step will have a `/plan`, `/exterior` path
// note that the "plan" selection step (3) uses both "3a" and this current "3b" path
export type CheckoutConfigParam = { ccfgId: string };
export const configuratorPlanBasePath = `/communities/:communityId/config/:ccfgId/:step/:subStep?/:roomLocationId?`;

// NOTE: Substep sentinel `-1` tells our steps to jump to the final sub step on render
export function createConfiguratorUrl(
  communityId: string,
  ccfgId: string,
  step: FlowStep = FlowStep.Plans,
  subStep?: string,
  // This is different than substep
  // it's intent is to be used in our QR code scan flow to load the correct camera on the package
  // selection step when users initially load the configurator
  roomLocationId?: string,
): string {
  return generatePath(configuratorPlanBasePath, {
    communityId,
    ccfgId,
    step,
    subStep: subStep || null,
    roomLocationId: roomLocationId || null,
  });
}

// configurations download path
export const configurationsDownloadPath = "/configurations/download/:checkoutConfigId";
export function createConfigurationsDownloadUrl(
  checkoutConfigId: string,
  reports: string[],
  includePricing: boolean,
  additionalSitePriceInCents?: number,
) {
  const params = new URLSearchParams({
    reports: reports.join(","),
    includePricing: String(includePricing),
  });
  if (additionalSitePriceInCents !== undefined) {
    params.set("additionalSitePriceInCents", String(additionalSitePriceInCents));
  }
  return generatePath(configurationsDownloadPath, { checkoutConfigId }) + `?${params.toString()}`;
}

// QR code scan path
// TODO: SC-78430 Add room parameter for future use in Jan launch
export const qrPath = "/qr";
export function createQrUrl(communityId: string, structureId: string, roomLocationId: string) {
  const params = new URLSearchParams({ c: communityId, s: structureId, r: roomLocationId });
  return `${qrPath}?${params.toString()}`;
}
